import React from 'react';
import { phoneCountries } from 'constants/phoneCountries';
import { normalizeDdi, splitStoredPhone } from 'utils/phone';

const findCountry = (ddi) => {
  const normalized = normalizeDdi(ddi);
  return phoneCountries.find((country) => country.ddi === normalized);
};

/** Telefone com bandeira e DDI, para leitura (ficha da consulta, resumo do paciente). */
const PhoneDisplay = ({ telephone, ddi, className }) => {
  const stored = splitStoredPhone(telephone, ddi);
  if (!stored.national) return null;

  const country = findCountry(stored.ddi);

  return (
    <span className={className || 'inline-flex items-center gap-1.5'}>
      {country?.flag && <span aria-hidden="true">{country.flag}</span>}
      <span className="tabular-nums">+{stored.ddi}</span>
      <span>{stored.national}</span>
    </span>
  );
};

export default PhoneDisplay;
